module.exports = __webpack_public_path__ + "static/media/minus-circle.1948d01d.svg";